// extracted by mini-css-extract-plugin
export default {"footer":"sb-footer_footer_dLoW9","footer--bottom-fixed":"sb-footer_footer--bottom-fixed_hRZFB","footer--justify-center":"sb-footer_footer--justify-center_rl0W0"};